export default {
  确认: "확인",
  取消: "취소",
  选择语言: "언어 선택",
  切换语言成功: "언어 전환 성공",
  首页: "홈",
  报单: "보고서 등록",
  团队: "팀",
  "交易进行中,请勿进行其他操作":
    "거래가 진행 중입니다. 다른 작업은 하지 마세요.",
  资金管理: "자금 관리",
  资金明细: "자금 상세",
  我的订单: "내 주문",
  订单详情: "주문 상세",
  没有更多了: "더 이상 없습니다",
  加载中: "로딩 중",
  代币价格: "토큰 가격",
  收益概览: "수익 개요",
  申购收益: "신청 수익",
  分享收益: "공유 수익",
  官方网站: "공식 웹사이트",
  官网: "공식 웹사이트",
  电报: "텔레그램",
  推特: "트위터",
  白皮书: "백서",
  申购金额: "신청 금액",
  请输入入金金额: "입금 금액을 입력하세요",
  快捷申购: "빠른 신청",
  申购比例: "신청 비율",
  赠币数量: "증정 토큰 수량",
  立即申购: "지금 신청",
  更多: "더 보기",
  订单: "주문",
  分红中: "배당 중",
  已完成: "완료",
  累计分红: "누적 배당",
  申购信息: "신청 정보",
  兑换数量: "환전 수량",
  赠币数量: "증정 토큰 수량",
  开始时间: "시작 시간",
  提现成功: "출금 성공",
  确认: "확인",
  订单编号: "주문 번호",
  团队数据总览: "팀 데이터 개요",
  我的推广链接: "내 프로모션 링크",
  复制: "복사",
  "分享此链接邀请好友加入团队，获取推广奖励":
    "이 링크를 공유하여 친구를 팀에 초대하고 프로모션 보상을 받으세요",
  团队业绩: "팀 실적",
  当前等级: "현재 레벨",
  今日收益: "오늘의 수익",
  申购收益: "신청 수익",
  分享收益: "공유 수익",
  团队用户: "팀 사용자",
  有效团队: "유효 팀",
  有效用户: "유효 사용자",
  无效团队: "무효 팀",
  直推用户: "직접 추천 사용자",
  有效直推: "유효 직접 추천",
  无效直推: "무효 직접 추천",
  资产余额数据概览: "자산 잔액 데이터 개요",
  提现: "출금",
  选中币种: "선택한 화폐",
  请输入入金金额: "입금 금액을 입력하세요",
  提现数量: "출금 수량",
  确认提现: "출금 확인",
  资金明细: "자금 상세",
  分红收入: "배당 수입",
  直推奖励: "직접 추천 보상",
  团队奖励: "팀 보상",
  申购金额: "신청 금액",
  兑换数量: "환전 수량",
  赠币数量: "증정 토큰 수량",
  开始时间: "시작 시간",
  立即申购: "지금 신청",
  确认: "확인",
  全部: "전체",
  收入: "수입",
  支出: "지출",
  请输入正确的金额: "올바른 금액을 입력하세요",
  申购成功: "신청 성공",
  申购失败: "신청 실패",
  提现失败: "출금 실패",
  提现信息: "출금 정보",
  提现币种: "출금 화폐",
  提现数量: "출금 수량",
  请选择币种: "화폐를 선택하세요",
  钱包余额不足: "지갑 잔액 부족",
  余额不足: "잔액 부족",
  提现手续费: "출금 수수료",
  间推奖励: "간접 추천 보상",
  团队奖励: "팀 보상",
  提现失败退还: "출금 실패 환불",
  ido申购: "IDO 신청",
  ido申购赠送: "IDO 신청 증정",
  链式去中心化全球点火网络: "체인 기반 탈중앙화 글로벌 이그니션 네트워크",
  协议永生: "프로토콜 영생",
  智能涌现: "지능 탄생",
  财富觉醒: "재산 각성",
  立即进入: "지금 입장",
  大区累计业绩: "대구역 누적 실적",
  小区累计业绩: "소구역 누적 실적",
  复制成功: "복사 성공",
  复制失败: "복사 실패",
  暂无数据: "데이터 없음",
  当DeFi遇上自主型DAO: "DeFi가 자율형 DAO를 만났을 때",
  历史最高: "역대 최고",
  历史最低: "역대 최저",
  当前价格: "현재 가격",
  报单累计收益: "보고서 등록 누적 수익",
  团队累计收益: "팀 누적 수익",
  报单金额: "보고서 등록 금액",
  快捷报单: "빠른 보고서 등록",
  请输入报单金额: "보고서 등록 금액을 입력하세요",
  报单比例: "보고서 등록 비율",
  报单信息: "보고서 등록 정보",
  进行中: "진행 중",
  已完成: "완료",
  累计收益: "누적 수익",
  立即报单: "지금 보고서 등록",
  请输入提现数量: "출금 수량을 입력하세요",
  提现确认: "출금 확인",
  "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除":
    "이번 출금의 체인상 Gas 수수료는 본인 부담입니다. 확인을 클릭하면 출금 절차가 진행되며, 출금 잔액이 우선 차감됩니다.",
  "操作后无法撤销，请谨慎认购":
    "작업 후에는 취소할 수 없습니다. 신중하게 구매하세요",
  我再想想: "다시 생각해볼게요",
  确认提现: "출금 확인",
  余额不足: "잔액 부족",
  直推奖励: "직접 추천 보상",
  团队奖励: "팀 보상",
  提现失败退还: "출금 실패 환불",
  平级收益: "동급 수익",
  每日释放: "매일 해제",
  提现TDL: "TDL 출금",
  报单失败: "보고서 등록 실패",
  绑定邀请人: "초대자 바인딩",
  报单成功: "보고서 등록 성공",
  提现比例: "출금 비율",
  入金支付说明: "입금 지불 설명",
  "您的实际支付由两部分组成，根据当前支付比例计算":
    "실제 지불 금액은 두 부분으로 구성되며, 현재 지불 비율에 따라 계산됩니다",
  支付TDL数量: "TDL 지불 수량",
  入金数量: "입금 수량",
  TDL支付比例: "TDL 지불 비율",
  "注：支付比例由平台设定，可能随时调整":
    "참고: 지불 비율은 플랫폼에서 설정하며, 언제든지 변경될 수 있습니다",
  我知道了: "알겠습니다",
  支付USDT数量: "USDT 지불 수량",
  USDT支付比例: "USDT 지불 비율",
  TDL实时价格: "TDL 실시간 가격",
  请先连接TCC链: "먼저 TCC 체인에 연결하세요",
  CUSD支付比例: "CUSD 지불 비율",
  支付CUSD数量: "CUSD 지불 수량",
  算力红利: "산력 이익",
  "当DeFi遇上自主型DAO闲置算力共享": "DeFi가 자율형 DAO를 만났을 때, 유휴한 계산력을 공유합니다",
  "全民节点分红智能涌现": "전체 노드의 배당이 지능적으로 발생합니다",
  "闲置算力共享·全民节点分红": "유휴한 계산력을 공유하고, 전체 노드의 배당을 받습니다",
  };
